import axios from 'axios'

class VerticalLifeApi {
  constructor (options = {}) {
    this.axios = axios.create({
      headers: {
        'X-Auth-Token': options.authToken
      }
    })
    this.axios.defaults.baseURL = options.baseUrl
  }

  fetchLeagues () {
    return this.axios.get('/api/v1/').then(response => {
      return response.data.seasons.reduce((aggr, curr) => {
        const year = curr.name
        return aggr.concat(curr.leagues.map(each => {
          return {
            id: each.url.match(/\/(\d+)$/)[1],
            name: year + ' ' + each.name
          }
        }))
      }, [])
    })
  }

  fetchEvents (leagueId) {
    return this.axios.get(`/api/v1/season_leagues/${leagueId}`).then(response => response.data.events)
  }

  fetchStages (eventId) {
    return this.axios(`/api/v1/events/${eventId}`).then(response => response.data.dcats)
  }

  fetchRounds (eventId, stageId) {
    return this.fetchStages(eventId).then(dcats => (dcats.find(p => p.dcat_id === stageId) || {}).category_rounds || [])
  }

  getStartingListUrl (round) {
    console.log('getStartingListUrl', round.routes[0].startlist, round)
    const baseUrl = this.axios.defaults.baseURL
    return baseUrl + round.routes[0].startlist
  }

  getRankingListUrl (round) {
    console.log('getRankingListUrl', round.result_url, round)
    const baseUrl = this.axios.defaults.baseURL
    return baseUrl + round.result_url
  }
}

export default VerticalLifeApi



// WEBPACK FOOTER //
// ./src/api/VerticalLifeApi.js